export interface CmsPageData {
	Slug: string;
	Teaser: CmsData | undefined;
	Headline: string;
	ShortDescription: string;
	Title: string;
	NoIndex: boolean;
	PageContent: string;
	publishedAt: string;
}

export interface CmsData {
	data: {
		attributes: unknown;
	};
}

export interface CmsImageData {
	alt: string | undefined;
	url: string;
	width: number;
	height: number;
}

export type ImageFormat = 'large' | 'small' | 'medium' | 'thumbnail' | undefined;

interface StrapiImage {
	url: string;
	width: number;
	height: number;
}

interface StrapiCmsImage extends StrapiImage {
	alternativeText?: string;
	formats: {
		[key in NonNullable<ImageFormat>]: StrapiImage;
	};
}

export function extractCmsImage(cmsImageData: CmsData, format: ImageFormat = undefined): CmsImageData {
	let data: StrapiCmsImage | StrapiImage;

	data = cmsImageData.data.attributes as StrapiCmsImage;

	if (typeof data !== 'object' || data === null) {
		throw new Error('No data found in CMS image.');
	}

	const { alternativeText, formats } = data as StrapiCmsImage;

	let alt: string | undefined;
	if (typeof alternativeText === 'string' && alternativeText.trim()) {
		alt = alternativeText.trim();
	}

	if (format && format in formats) {
		data = formats[format];
	}

	return {
		alt,
		url: data.url,
		width: data.width,
		height: data.height
	};
}
